import create from 'zustand'
import { persist } from 'zustand/middleware'

type TProfileLayoutState = {
  pageElement?: string
  setPageElement: (pageElement: string) => void
}
export const useProfileLayout = create<TProfileLayoutState>((set) => ({
  pageElement: 'KARYA',
  setPageElement: (pageElement) =>
    set(() => ({
      pageElement,
    })),
}))

type TProfileCertificateOnboardingState = {
  isRendered?: boolean
  isFinished?: boolean
  setRendered: () => void
  setFinished: () => void
}
export const useProfileCertificateOnboarding =
  create<TProfileCertificateOnboardingState>(
    persist(
      (set) => ({
        isRendered: false,
        isFinished: false,
        setRendered: () =>
          set(() => ({
            isRendered: true,
          })),
        setFinished: () =>
          set(() => ({
            isFinished: true,
          })),
      }),
      {
        name: 'PROFILE_CERTIFICATE_ONBOARDING_STORAGE_KEY',
      }
    )
  )
